export const appId = 'KkLcoJcJsqpGeffWNZdK7hKjd8rUXi5Zy194hTOQ';
export const restKey = 'biojTvhL2QXaOImFjzGwivYB1L5XPAHas7lDpCqx';
export const serverUrl = 'https://parseapi.back4app.com/';
export const razorPayKey = 'rzp_test_gvKhAUPt3TLPdt';
export const headers = {
  'X-Parse-Application-Id': appId,
  'X-Parse-REST-API-Key': restKey,
  'Content-Type': 'application/json',
};
